import { isRootForm, INTERNAL_LOG } from '@ecom-zform/core';
export var warning = function (valid, message) {
    // Support uglify
    if (process.env.NODE_ENV !== 'production' && !valid && console !== undefined) {
        // eslint-disable-next-line no-console
        console.error('Warning: '.concat(message));
    }
};
var prefix = function (component, form) {
    return "[ZForm:" + component + "]" + (form ? "[path:" + (isRootForm(form) ? 'root' : form.address.string) + "]" : '');
};
export var devWarning = function (valid, component, message, form) {
    if (message.includes(INTERNAL_LOG))
        return;
    warning(valid, prefix(component, form) + " " + message);
};
export var devError = function (valid, component, message, form) {
    if (process.env.NODE_ENV !== 'production' && !valid && console !== undefined) {
        throw Error(prefix(component, form) + " " + message);
    }
};
export var devLog = function (component, message, form) {
    if (message.includes(INTERNAL_LOG))
        return;
    if (process.env.NODE_ENV !== 'production' && console !== undefined) {
        // eslint-disable-next-line no-console
        console.log("LOG: " + prefix(component, form) + " " + message);
    }
};
